<button
  type="button"
  [vxMenuTriggerFor]="panel"
  vxMenuSide="top"
  vxMenuAlign="start"
  [class]="classes().trigger">
  <vx-avatar [src]="avatarSrc()" [initials]="userInitials()" />
  <span [class]="classes().text">
    <span class="truncate text-xs font-medium text-zinc-200">{{ userName() }}</span>
    @if (activeOrg(); as org) {
      <span class="truncate text-xs text-zinc-400">{{ org.name }}</span>
    }
  </span>
  @if (!compact()) {
    <vx-icon name="caret-up-down-bold" size="sm" class="ms-auto text-zinc-400" />
  }
</button>

<ng-template #panel>
  <vx-menu class="w-64" [flush]="true">
    <div class="p-1.5">
      <div
        cdkMenuItem
        class="flex cursor-pointer flex-col rounded-btn px-2 py-1.5 select-none focus:outline-hidden focus-visible:bg-zinc-700 hover:bg-zinc-700"
        (cdkMenuItemTriggered)="accountSelected.emit()">
        <span class="truncate text-xs font-medium text-zinc-200">{{ userName() }}</span>
        @if (userEmail(); as email) {
          <span class="truncate text-xs text-zinc-400">{{ email }}</span>
        }
      </div>
    </div>
    @for (org of orgs(); track org.id) {
      <vx-menu-separator />
      <!-- active org = full-bleed band (per design); the inner row keeps its
           radius only for the hover/focus state -->
      <div class="p-1.5" [ngClass]="{ 'bg-zinc-750': isActive(org) }">
        <div
          cdkMenuItem
          class="flex h-10 cursor-pointer items-center gap-2 rounded-btn px-2 text-xs text-zinc-200 select-none focus:outline-hidden focus-visible:bg-zinc-700 hover:bg-zinc-700"
          [ngClass]="{ 'text-zinc-50': isActive(org) }"
          (cdkMenuItemTriggered)="orgSelected.emit(org)">
          <vx-avatar
            size="sm"
            shape="rounded"
            [initials]="org.initial ?? org.name.charAt(0).toUpperCase()"
            [tone]="isActive(org) ? 'accent' : 'neutral'" />
          <span class="truncate">{{ org.name }}</span>
          @if (org.badge; as badge) {
            <vx-badge class="ms-auto" [tone]="badgeTone(org)">{{ badge }}</vx-badge>
          }
        </div>
      </div>
    }
    <vx-menu-separator />
    <div class="p-1.5">
      <ng-content></ng-content>
    </div>
  </vx-menu>
</ng-template>
